import axios from 'axios'
import { API_URL } from '../config/app.config'

export const httpbase = () =>{
  const headers= {
    'Accept':'*/*',
    'access-control-allow-origin': '*',
  }
  let instance = axios.create({
    baseURL:API_URL + '/api/',
    headers:headers,
  })

  instance.interceptors.response.use((response)=>{
    return response;
  },(error)=>{
    return Promise.reject(error);
  });

  return instance;
}



